<template>
  <div>
    <v-row>
      <v-col class="pt-0 col-sm-4">
        <v-text-field
            filled
            dense
            label="CEP"
            autocomplete="cep"
            name="cep"
            v-model="cep"
            prepend-inner-icon="mdi-format-text"
            hide-details="auto"
            placeholder=" "
            type="text"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    props: {
      zipcode: String
    },
    watch: {
      zipcode() {
        this.cep = this.zipcode;
      },
      cep() {
        if (this.cep === this.zipcode) {
          //return;
        }
        this.cep = this.cep.toString().replace(/[^0-9]/g,'')

        if (this.cep.length === 8) {
          const payload = {
            zipcode: this.cep
          };

          this.$api.post('/address/zipcode.info', payload)
            .then((response) => {
              this.$emit('cepData', {
                zipcode: this.cep,
                city: response.data.city.name,
                city_id: response.data.city.id,
                street: response.data.street,
                district: response.data.district,
                state_short: response.data.city.state_short
              })
            });
        }
      }
    },
    data() {
      return {
        cep: null
        //street: null
      }
    }
  }
</script>

<style>
</style>
